export function calculateDashboardMetrics(conversations) {
    const today = new Date().toISOString().split("T")[0];
    const currentMonth = new Date().getMonth();

    const leadsHoje = conversations.filter(
        (c) => c.createdAt.startsWith(today)
    ).length;

    const semResposta = conversations.filter(
        (c) => !c.responded
    ).length;

    const agendamentosHoje = conversations.filter(
        (c) =>
            c.hasAppointment &&
            c.createdAt.startsWith(today)
    ).length;

    const matriculasMes = conversations.filter(
        (c) =>
            c.enrolled &&
            new Date(c.createdAt).getMonth() === currentMonth
    ).length;

    // esse número normalmente viria de outro nó (alunos ativos)
    const totalAlunos = 323;

    const diasParaFerias = 123; // depois vira cálculo real

    return {
        leadsHoje,
        semResposta,
        agendamentosHoje,
        matriculasMes,
        totalAlunos,
        diasParaFerias,
    };
}